import './CustomerOrderDetail.scss';
import Component from './CustomerOrderDetail.js';
export default Component;
